import React from 'react';

import makeStyles from '@mui/styles/makeStyles';

import {
  Checkbox,
  FormControl,
  Grid,
  IconButton,
  Input,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  Tooltip,
} from '@mui/material';

import DownloadIcon from '@mui/icons-material/CloudDownload';

import KDatePicker from '../../components/KDatePicker';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: '8px',
    borderBottom: '2px solid black',
    marginBottom: '16px',
  },
  usersSelectControl: {
    marginTop: '-2px',
  },
  usersSelect: {
    minWidth: 220,
    maxWidth: 300,
    paddingLeft: '4px',
  },
  downloadIcon: {
    marginTop: '6px',
    textAlign: 'center',
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const ControlPanel = ({
  startDate,
  startDateSetter,
  lastIncludedDate,
  lastIncludedDateSetter,
  allUsers,
  selectedUsers,
  selectedUsersSetter,
  downloadFunc,
}) => {
  const classes = useStyles();

  const handleUsersMenuChange = (event) => {
    selectedUsersSetter(event.target.value);
  };

  return (
    <Grid className={classes.root} container justifyContent="space-between" spacing={1}>
      <Grid item md={3}>
        <KDatePicker label="Start Date" value={startDate} onChange={(newDate) => startDateSetter(newDate)} />
      </Grid>
      <Grid item md={3}>
        <KDatePicker
          label="End Date"
          value={lastIncludedDate}
          onChange={(newDate) => lastIncludedDateSetter(newDate)}
        />
      </Grid>
      <Grid item md={5}>
        <FormControl variant="standard" className={classes.usersSelectControl}>
          <InputLabel>Users</InputLabel>
          <Select
            variant="standard"
            className={classes.usersSelect}
            multiple
            value={selectedUsers}
            onChange={handleUsersMenuChange}
            input={<Input />}
            renderValue={(selected) => `${selected.length} Chosen`}
            MenuProps={MenuProps}
          >
            {allUsers.map((user) => (
              <MenuItem key={user.personId} value={user}>
                <Checkbox checked={selectedUsers.indexOf(user) > -1} />
                <ListItemText primary={user.name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item md={1}>
        <IconButton className={classes.downloadIcon} onClick={() => downloadFunc()} size="large">
          <Tooltip title="Download Report">
            <DownloadIcon />
          </Tooltip>
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default ControlPanel;
